module.exports = __webpack_public_path__ + "img/wechattu3.c6f3bf68.png";